<template>
  <b-modal
    ref="self"
    class="card-form-modal"
    :active.sync="active"
    :custom-class="'dialog'"
    has-modal-card
    trap-focus
    :destroy-on-hide="true"
    aria-role="dialog"
    scroll="keep"
    :taxClassificationIsChecked="taxClassificationIsChecked"
    :width="width"
    aria-modal>
    <template>
      <validation-observer v-slot="{ handleSubmit }">
        <div class="modal-card">
          <header class="modal-card-head">
            <button class="modal-close is-large" aria-label="close" @click="cancel"></button>
          </header>
          <section class="modal-card-body">
            <div class="white-board"></div>
            <div class="pdfViewer" style="position:relative;">
              <div ref="pdf"
                   style="position:absolute">
              </div>
              <div v-if="entity" id="full-name-danger-icon">
                <b-tooltip
                  type="is-danger"
                  :label="entity.fullName"
                  multilined>
                  <b-icon v-if="showFullNameDangerIconIfDifferent"
                          class="mdi mdi-alert-circle mdi-24px" type="is-danger"></b-icon>
                </b-tooltip>
              </div>
              <div v-if="entity" id="company-danger-icon">
                <b-tooltip
                  type="is-danger"
                  :label="entity.companyName"
                  multilined>
                  <b-icon v-if="showCompanyDangerIconIfDifferent"
                          class="mdi mdi-alert-circle mdi-24px" type="is-danger"></b-icon>
                </b-tooltip>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot" :style="styleObject" >
            <div v-if="openExistW9" class="modal-card-foot-options">
              <b-select v-model="status"
                        :expanded=true
                        style="padding-right: 15px">
                <option v-for="option in statuses"
                        :value="option.value" :key="option.value">{{ option.text }}</option>
              </b-select>
              <div>
                <b-checkbox :disabled="!showFullNameDangerIconIfDifferent
              && !showCompanyDangerIconIfDifferent"
                            class="has-text-danger"
                            v-model="skipAllDifferences">Skip all differences</b-checkbox>
              </div>
            </div>
            <div class="modal-card-foot-buttons">
              <button class="button" type="button" @click="cancel">Cancel</button>
              <button class="button is-success" @click="handleSubmit(submit)">Submit</button>
            </div>
          </footer>
        </div>
      </validation-observer>
    </template>
  </b-modal>
</template>

<script>
import * as PDFJSViewer from 'pdfjs-dist/legacy/web/pdf_viewer';
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
import { PDFDocument } from 'pdf-lib';
import fontKit from '@pdf-lib/fontkit';
import {
  getTemplateW9Pdf as getTemplateW9PdfContractor,
  saveW9PDF,
  getExistW9Pdf,
  updateW9Status,
} from '../../api/contractor';
import {
  getTemplateW9Pdf as getTemplateW9PdfPartner,
  savePartnerW9PDF,
  getPartnerW9Pdf,
  updatePartnerW9Status,
} from '../../api/partner';

pdfjsLib.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/build/pdf.worker.entry.js');

export default {
  name: 'W9TaxForm',
  props: {
    entityId: [String, Number],
    entityType: {
      type: String,
      default: 'contractor',
      validator: (value) => ['contractor', 'partner'].includes(value),
    },
    active: Boolean,
    openExistW9: Number,
    entity: Object,
  },
  data() {
    return {
      pdfDoc: null,
      nameElement: null,
      businessNameElement: null,
      taxClassificationIsChecked: 0,
      checkboxes: null,
      ssnElement1: null,
      ssnElement2: null,
      ssnElement3: null,
      einElement1: null,
      einElement2: null,
      addressElement: null,
      cityElement: null,
      signatureSign: null,
      federalTaxClassificationLimitedLiabilityInput: null,
      federalTaxClassificationOtherInput: null,
      federalTaxClassificationLimitedLiabilityCheckbox: null,
      federalTaxClassificationOtherCheckbox: null,
      isValid: true,
      isNotValidMessages: 'These fields are required.',
      width: '1270px',
      skipDifferencesNewValue: null,
      newStatus: null,
      showFullNameDangerIconIfDifferent: false,
      statuses: [
        { text: 'Pending', value: 'Pending' },
        { text: 'Verified', value: 'Verified' },
        { text: 'Rejected', value: 'Rejected' },
      ],
      styleObject: {
        justifyContent: 'space-between',
      },
    };
  },
  computed: {
    showCompanyDangerIconIfDifferent() {
      if (!this.entity?.w9?.isEIN) {
        return false;
      }
      return (
        (this.entity.w9.companyName || '').toLowerCase()
        !== (this.entity.companyName || '').toLowerCase()
      );
    },
    skipAllDifferences: {
      get() {
        if (this.entity && this.entity.w9) {
          return Boolean(Number(this.entity.w9.skipDifferences));
        }
        return null;
      },
      set(skipDifferences) {
        if (this.entity) {
          this.skipDifferencesNewValue = skipDifferences;
          return skipDifferences;
        }
        return null;
      },
    },
    status: {
      get() {
        if (this.entity && this.entity.w9) {
          return this.entity.w9.status;
        }
        return null;
      },
      set(status) {
        this.newStatus = status;
        return status;
      },
    },
  },
  methods: {
    cancel() {
      this.active = false;
      this.$emit('close');
    },

    submit() {
      if (!this.pdfDoc) {
        return;
      }
      if (this.openExistW9) {
        const formData = new FormData();
        formData.set('id', this.entityId);
        formData.set('status', this.newStatus ? this.newStatus : this.entity.w9.status);
        formData.set('skipDifferences', (this.skipDifferencesNewValue !== null ? this.skipDifferencesNewValue : this.entity.w9.skipDifferences) ? '1' : '0');

        const updateMethod = this.entityType === 'partner' ? updatePartnerW9Status : updateW9Status;
        updateMethod(formData).then((response) => {
          if (response.data.error) {
            this.toast(response.data.message, 'is-danger');
          } else {
            this.active = false;
            this.$buefy.toast.open({ message: response.data.message, type: 'is-success', duration: 3000 });
            this.$emit('submit', response);
          }
        })
          .catch(() => this.$buefy.toast.open({ message: 'An unexpected error occurred, please contact support@enhancify.com', type: 'is-danger' }));
      } else {
        const ssn = this.ssnElement1.value + this.ssnElement2.value + this.ssnElement3.value;
        const ein = this.einElement1.value + this.einElement2.value;
        this.isValid = true;
        this.isNotValidMessages = 'These fields are required.';

        if (!this.nameElement.value) {
          this.nameElement.classList.add('redBorder');
          this.isValid = false;
        } else {
          this.nameElement.classList.remove('redBorder');
        }

        if (ssn.length > 0 && ssn.length < 9) {
          this.ssnElement1.classList.add('redBorder');
          this.ssnElement2.classList.add('redBorder');
          this.ssnElement3.classList.add('redBorder');
          this.isValid = false;
          this.isNotValidMessages = 'Please enter a valid 9-digit TIN number.';
        }
        if (ein.length > 0 && ein.length < 9) {
          this.einElement1.classList.add('redBorder');
          this.einElement2.classList.add('redBorder');
          this.isValid = false;
          this.isNotValidMessages = 'Please enter a valid 9-digit TIN number.';
        }

        const isInvalidTinFormat = (digits) => (
          /^(\d)\1{8}$/.test(digits)
          || '0123456789'.includes(digits)
          || '9876543210'.includes(digits)
        );
        if (ssn.length === 9 && isInvalidTinFormat(ssn)) {
          this.ssnElement1.classList.add('redBorder');
          this.ssnElement2.classList.add('redBorder');
          this.ssnElement3.classList.add('redBorder');
          this.isValid = false;
          this.isNotValidMessages = 'The TIN number cannot contain nine the same digits or nine consecutive digits.';
        }
        if (ein.length === 9 && isInvalidTinFormat(ein)) {
          this.einElement1.classList.add('redBorder');
          this.einElement2.classList.add('redBorder');
          this.isValid = false;
          this.isNotValidMessages = 'The TIN number cannot contain nine the same digits or nine consecutive digits.';
        }

        if (!ssn && !ein) {
          this.ssnElement1.classList.add('redBorder');
          this.ssnElement2.classList.add('redBorder');
          this.ssnElement3.classList.add('redBorder');
          this.einElement1.classList.add('redBorder');
          this.einElement2.classList.add('redBorder');
          this.isValid = false;
        }

        if (ssn && ein) {
          this.ssnElement1.classList.add('redBorder');
          this.ssnElement2.classList.add('redBorder');
          this.ssnElement3.classList.add('redBorder');
          this.einElement1.classList.add('redBorder');
          this.einElement2.classList.add('redBorder');
          this.isValid = false;
          this.isNotValidMessages = 'Please enter one TIN option only (SSN or EIN).';
        }

        if (!this.addressElement.value) {
          this.addressElement.classList.add('redBorder');
          this.isValid = false;
        } else {
          this.addressElement.classList.remove('redBorder');
        }
        if (!this.cityElement.value) {
          this.cityElement.classList.add('redBorder');
          this.isValid = false;
        } else {
          this.cityElement.classList.remove('redBorder');
        }
        if (!this.signatureSign.value) {
          this.signatureSign.classList.add('redBorder');
          this.isValid = false;
        } else {
          this.signatureSign.classList.remove('redBorder');
        }
        if (this.federalTaxClassificationLimitedLiabilityCheckbox.checked
          && !this.federalTaxClassificationLimitedLiabilityInput.value) {
          this.federalTaxClassificationLimitedLiabilityInput.classList.add('redBorder');
          this.isValid = false;
        } else {
          this.federalTaxClassificationLimitedLiabilityInput.classList.remove('redBorder');
        }
        if (this.federalTaxClassificationOtherCheckbox.checked
          && !this.federalTaxClassificationOtherInput.value) {
          this.federalTaxClassificationOtherInput.classList.add('redBorder');
          this.isValid = false;
        } else {
          this.federalTaxClassificationOtherInput.classList.remove('redBorder');
        }
        const checkedCheckboxes = document.querySelectorAll('.checkBox input[type="checkbox"]:checked');
        this.taxClassificationIsChecked = checkedCheckboxes.length !== 0 ? 1 : 0;
        if (!this.taxClassificationIsChecked) {
          this.checkboxes.forEach((item) => {
            item.classList.add('redBorder');
          });
          this.isValid = false;
        } else {
          this.checkboxes.forEach((item) => {
            item.classList.remove('redBorder');
          });
        }
        if (!this.isValid) {
          this.$buefy.toast.open({ message: this.isNotValidMessages, type: 'is-danger', duration: 5000 });
        } else {
          const formData = new FormData();
          formData.set('id', this.entityId);
          const inputTexts = document.querySelectorAll('input[type="text"]');
          inputTexts.forEach((item) => {
            if (item.id === '938R') {
              formData.set('fullName', item.value);
            }
            if (item.id === '939R') {
              formData.set('companyName', item.value);
            }
            if (item.id === '956R') {
              if (item.value) {
                formData.set('isSSN', '1');
              }
            }
            if (item.id === '959R') {
              if (item.value) {
                formData.set('isEIN', '1');
              }
            }
            this.pdfDoc.annotationStorage.setValue(item.id, { value: item.value });
          });
          const federalTaxClassification = document.querySelectorAll('input[type="checkbox"]');
          federalTaxClassification.forEach((item) => {
            this.pdfDoc.annotationStorage.setValue(item.id, { value: item.checked });
          });
          const nameRequester = document.querySelectorAll('textarea');
          nameRequester.forEach((item) => {
            this.pdfDoc.annotationStorage.setValue(item.id, { value: item.value });
          });
          this.pdfDoc.saveDocument().then((pdfBytes) => {
            const file = new Blob([pdfBytes], { type: 'application/pdf' });
            formData.append('file', file, 'fw9.pdf');
            if (this.entityId) {
              const saveMethod = this.entityType === 'partner' ? savePartnerW9PDF : saveW9PDF;
              saveMethod(formData).then((response) => {
                if (response.data.error) {
                  this.toast(response.data.message, 'is-danger');
                } else {
                  this.active = false;
                  this.$buefy.toast.open({ message: response.data.message, type: 'is-success', duration: 3000 });
                  this.$emit('submit', response);
                }
              })
                .catch(() => this.$buefy.toast.open({ message: 'An unexpected error occurred, please contact support@enhancify.com', type: 'is-danger' }));
            } else {
              this.active = false;
              this.$buefy.toast.open({ message: 'An unexpected error occurred, please contact support@enhancify.com', type: 'is-danger' });
              this.$emit('close');
            }
          });
        }
      }
    },
  },
  mounted() {
    // Init showFullNameDangerIconIfDifferent
    if (this.entity && this.entity.w9) {
      this.showFullNameDangerIconIfDifferent = (this.entity.fullName ?? '').toLowerCase()
          !== (this.entity.w9.fullName ?? '').toLowerCase();
    }
    if (this.openExistW9) {
      const getExistMethod = this.entityType === 'partner' ? getPartnerW9Pdf : getExistW9Pdf;
      getExistMethod(this.entityId).then((response) => {
        const container = this.$refs.pdf;
        const eventBus = new PDFJSViewer.EventBus();
        const ENABLE_XFA = true;
        const loadingTask = pdfjsLib.getDocument({
          data: atob(response.data),
          enableXfa: ENABLE_XFA,
        });
        loadingTask.promise.then((pdfDocument) => {
          this.$data.pdfDoc = pdfDocument;
          const pdfViewer = new PDFJSViewer.PDFViewer({
            container,
            viewer: container,
            eventBus,
          });
          // eslint-disable-next-line no-underscore-dangle
          pdfViewer._currentScale = 1.5;
          pdfViewer.setDocument(pdfDocument);
        }).then(() => {
          setTimeout(() => {
            const annotationLayer = document.querySelector('.annotationLayer');
            if (annotationLayer) {
              const fields = annotationLayer.querySelectorAll('input[type="text"], textarea, input[type="checkbox"]');
              fields.forEach((item) => {
                item.classList.add('w9-annotation-layer-element');
                if (item.type === 'checkbox') {
                  item.setAttribute('disabled', 'true');
                } else {
                  item.setAttribute('readonly', 'true');
                }
              });
            }
            const whiteBoard = document.querySelector('.white-board');
            if (whiteBoard) whiteBoard.style.display = 'none';
          }, 500);
        });
      })
        .catch(() => {
          this.$buefy.toast.open({ message: 'An unexpected error occurred, please contact support@enhancify.com', type: 'is-danger' });
        });
    } else {
      this.styleObject = {
        justifyContent: 'end',
      };
      const getTemplateMethod = this.entityType === 'partner' ? getTemplateW9PdfPartner : getTemplateW9PdfContractor;
      getTemplateMethod().then(async (response) => {
        const pdfDoc = await PDFDocument.load(response.data);
        const fontUrl = '/fonts/signature-webfont.ttf';
        const fontBytes = await fetch(fontUrl).then((res) => res.arrayBuffer());
        pdfDoc.registerFontkit(fontKit);
        const signatureFont = await pdfDoc.embedFont(fontBytes);
        const firstPage = pdfDoc.getPages()[0];

        const form = pdfDoc.formCache.access();
        if (form.hasXFA()) {
          form.deleteXFA();
        }
        const signature = form.createTextField('topmostSubform[0].Page1[0].Signature[0].f1_16[0]');
        const date = form.createTextField('topmostSubform[0].Page1[0].Signature[0].f1_17[0]');
        date.setText(new Date().toLocaleDateString('en-US',
          { month: '2-digit', day: '2-digit', year: 'numeric' }));
        signature.addToPage(firstPage, {
          x: 135, y: 228, width: 170.8, height: 24, borderWidth: 0,
        });
        date.addToPage(firstPage, {
          x: 415, y: 230, width: 100.8, height: 20, borderWidth: 0,
        });
        signature.updateAppearances(signatureFont);
        date.acroField.setDefaultAppearance('/Helv 14 Tf');

        const pdfBytes = await pdfDoc.save();

        const container = this.$refs.pdf;
        const eventBus = new PDFJSViewer.EventBus();
        const ENABLE_XFA = true;
        const loadingTask = pdfjsLib.getDocument({
          data: pdfBytes,
          enableXfa: ENABLE_XFA,
        });
        loadingTask.promise.then((pdfDocument) => {
          this.$data.pdfDoc = pdfDocument;
          const pdfViewer = new PDFJSViewer.PDFViewer({
            container,
            viewer: container,
            eventBus,
          });
          // eslint-disable-next-line no-underscore-dangle
          pdfViewer._currentScale = 1.5;
          pdfViewer.setDocument(pdfDocument);
        }).then(() => {
          setTimeout(() => {
            const annotationLayer = document.querySelector('.annotationLayer');
            if (annotationLayer) {
              this.nameElement = document.getElementById('938R');
              this.businessNameElement = document.getElementById('939R');
              this.federalTaxClassificationLimitedLiabilityCheckbox = document.getElementById('946R');
              this.federalTaxClassificationLimitedLiabilityInput = document.getElementById('947R');
              this.federalTaxClassificationOtherCheckbox = document.getElementById('948R');
              this.federalTaxClassificationOtherInput = document.getElementById('949R');
              const exemptionsPayeeCodeElement = document.getElementById('950R');
              const exemptionsFATCAElement = document.getElementById('951R');
              this.ssnElement1 = document.getElementById('956R');
              this.ssnElement2 = document.getElementById('957R');
              this.ssnElement3 = document.getElementById('958R');
              this.einElement1 = document.getElementById('959R');
              this.einElement2 = document.getElementById('960R');
              this.addressElement = document.getElementById('952R');
              this.cityElement = document.getElementById('953R');
              this.signatureSign = document.querySelector('input[name="topmostSubform[0].Page1[0].Signature[0].f1_16[0]"]');
              const signatureDate = document.querySelector('input[name="topmostSubform[0].Page1[0].Signature[0].f1_17[0]"]');
              const requesterNameElement = document.getElementById('954R');
              const listAccountElement = document.getElementById('955R');
              this.checkboxes = document.querySelectorAll('.checkBox input[type="checkbox"]');

              this.nameElement.focus();
              this.nameElement.setAttribute('maxlength', '255');
              this.businessNameElement.setAttribute('maxlength', '250');
              this.addressElement.setAttribute('maxlength', '255');
              this.cityElement.setAttribute('maxlength', '255');
              requesterNameElement.setAttribute('maxlength', '255');
              listAccountElement.setAttribute('maxlength', '255');
              this.federalTaxClassificationOtherInput.setAttribute('maxlength', '50');
              exemptionsPayeeCodeElement.setAttribute('maxlength', '11');
              exemptionsFATCAElement.setAttribute('maxlength', '18');
              this.signatureSign.setAttribute('maxlength', '255');
              this.signatureSign.style.fontSize = '19px';
              signatureDate.setAttribute('readonly', 'true');

              annotationLayer.addEventListener('click', (event) => {
                if (event.target.matches('input[type="text"]')) {
                  event.target.blur();
                  event.target.focus();
                }
                if (event.target.matches('input[type="checkbox"]')) {
                  this.checkboxes.forEach((item) => {
                    const currentItem = item;
                    currentItem.classList.remove('redBorder');
                    if (currentItem !== event.target) {
                      currentItem.checked = false;
                    }
                  });
                }
              });
              annotationLayer.addEventListener('keypress', (event) => {
                if (event.target.matches('input[type="checkbox"]')) {
                  const checkbox = event.target;
                  if (event.keyCode === 13) {
                    event.preventDefault();
                    checkbox.checked = !checkbox.checked;
                    this.checkboxes.forEach((item) => {
                      const currentItem = item;
                      if (currentItem !== event.target) {
                        currentItem.checked = false;
                      }
                    });
                  }
                }
              });
              annotationLayer.addEventListener('input', (event) => {
                if (event.target.matches('input[type="text"].comb')) {
                  const { target } = event;
                  target.value = target.value.replace(/\D+|\s+/gu, '');
                  if (event.target.id === '956R' && event.target.value.length >= 3) {
                    setTimeout(() => {
                      this.ssnElement2.focus();
                    });
                  }
                  if (event.target.id === '957R' && event.target.value.length >= 2) {
                    setTimeout(() => {
                      this.ssnElement3.focus();
                    });
                  }
                  if (event.target.id === '959R' && event.target.value.length >= 2) {
                    setTimeout(() => {
                      this.einElement2.focus();
                    });
                  }
                  if (event.target.id === '956R' || event.target.id === '957R' || event.target.id === '958R'
                    || event.target.id === '959R' || event.target.id === '960R') {
                    this.ssnElement1.classList.remove('redBorder');
                    this.ssnElement2.classList.remove('redBorder');
                    this.ssnElement3.classList.remove('redBorder');
                    this.einElement1.classList.remove('redBorder');
                    this.einElement2.classList.remove('redBorder');
                  }
                }
                if (event.target.matches('input[type="text"]')) {
                  if (event.target.id === '938R') {
                    this.nameElement.classList.remove('redBorder');
                  }
                  if (event.target.id === '939R') {
                    this.businessNameElement.classList.remove('redBorder');
                  }
                  if (event.target.id === '952R') {
                    this.addressElement.classList.remove('redBorder');
                  }
                  if (event.target.id === '953R') {
                    this.cityElement.classList.remove('redBorder');
                  }
                  if (event.target.name === 'topmostSubform[0].Page1[0].Signature[0].f1_16[0]') {
                    this.signatureSign.classList.remove('redBorder');
                  }
                  if (event.target.id === '947R') {
                    this.federalTaxClassificationLimitedLiabilityInput.classList.remove('redBorder');
                  }
                  if (event.target.id === '949R') {
                    this.federalTaxClassificationOtherInput.classList.remove('redBorder');
                  }
                }
              });
            }
            const whiteBoard = document.querySelector('.white-board');
            if (whiteBoard) whiteBoard.style.display = 'none';
          }, 500);
        });
      });
    }
  },
};
</script>
<style scoped lang="css">
#full-name-danger-icon{
  position: absolute;
  top: 200px;
  left: 95px;
}
#company-danger-icon{
  position: absolute;
  top: 247px;
  left: 95px;
}
@-moz-document url-prefix() {
  .annotationLayer {
    position: absolute!important;
    top: 1px!important;
    left: 3px!important
  }
}
</style>

<style scoped lang="stylus">
@font-face {
  font-family Signature;
  src url('/fonts/signature-webfont.ttf');
}
@import "~pdfjs-dist/legacy/web/pdf_viewer.css"
@media (max-width: 768px)
  .modal-card-body .pdfViewer
    min-height: 400px;
  .modal-card-foot-options
    display flex;
    flex-wrap wrap;
    justify-content start;
    align-content space-between;
    align-items center;
  .modal-card-foot-options div:first-child {
    min-height 50px;
  }
  .modal-card-foot-buttons
    display flex;
    flex-wrap wrap;
    justify-content end;
  .dialog .modal-card .modal-card-foot .modal-card-foot-buttons button
    margin-right 0.5em;
  .modal-card-foot
    padding 10px;
    align-items stretch;
@media (max-width: 629px)
  .modal-card-foot-buttons button:first-child
    margin-bottom 10px
@media (min-width: 769px)
  .modal-card-foot-options
    display flex;
    flex-wrap unset;
    align-items end;
    justify-content unset;
  .modal-card-foot-options div:first-child {
    min-height 0;
  }
  .modal-card-foot
    padding 20px;
    align-items center;
    min-height unset;
.modal-card-foot-buttons
  align-content space-between
  .button.is-success
    background-color #68BA62 !important
    border-color #68BA62 !important
    &:hover
      background-color #17B548 !important
  .button:not(.is-success)
    background-color transparent !important
    border-color #68BA62 !important
    color #68BA62 !important
    &:hover
      background-color #17B548 !important
      border-color #17B548 !important
      color #fff !important;
.dialog .modal-card .modal-card-body .field
  margin-top: 0;
.dialog .modal-card .modal-card-head
  height 25px;
.modal .animation-content .modal-card
  max-width inherit
  min-width 230px;
.modal .animation-content .modal-card >>> .modal-card-body
  padding-top 0;
  padding-bottom 0;
div>>>.page .annotationLayer section input[name='topmostSubform[0].Page1[0].Signature[0].f1_16[0]']
  font-family Signature
  font-size 38px!important
div>>>.page .annotationLayer section input[name='topmostSubform[0].Page1[0].Signature[0].f1_17[0]']
  position relative
div>>>.page .annotationLayer section[data-annotation-id='938R']
  top 187.999px!important
  left 113.6px!important
  width 1032.8px!important
  height 28.001px!important
div>>>.page .annotationLayer section[data-annotation-id='939R']
  top 235.999px!important
  left 113.6px!important
  width 1032.8px!important
  height 28.001px!important
div>>>.page .annotationLayer section[data-annotation-id='940R']
  @supports (-moz-appearance:none) and (will-change:auto)
    left 130px!important
  @supports (-webkit-font-smoothing:antialiased)
    left 132px!important
  top 319px!important
  width 16px!important
  height 16px!important
div>>>.page .annotationLayer section[data-annotation-id='942R']
  top 314px!important
  left 358px!important
  width 16px!important
  height 16px!important
div>>>.page .annotationLayer section[data-annotation-id='943R']
  top 315px!important
  left 503px!important
  width 16px!important
  height 16px!important
div>>>.page .annotationLayer section[data-annotation-id='944R']
  top 316px!important
  left 648px!important
  width 16px!important
  height 16px!important
div>>>.page .annotationLayer section[data-annotation-id='945R']
  top 314px!important
  left 791px!important
  width 16px!important
  height 16px!important
div>>>.page .annotationLayer section[data-annotation-id='946R']
  top 368px!important
  left 131px!important
  width 16px!important
  height 16px!important
div>>>.page .annotationLayer section[data-annotation-id='947R']
  top: 355px !important;
  left: 823px !important;
  width: 68px !important;
  height: 28px !important;
div>>>.page .annotationLayer section[data-annotation-id='948R']
  top 460px!important
  left 131px!important
  width 16px!important
  height 16px!important
div>>>.page .annotationLayer section[data-annotation-id='949R']
  top 455px!important
  left 326px!important
  width 578.5px!important
  height 24px!important
  @media screen and (-webkit-min-device-pixel-ratio:0) and (min-resolution:.001dpcm)
    top 452px!important
div>>>.page .annotationLayer section[data-annotation-id='950R']
  left 1080px!important
  top 334px!important
  width 69.26px!important
  height 24px!important
div>>>.page .annotationLayer section[data-annotation-id='951R']
  top 408px!important
  left 1005px!important
  width 144px!important
  height 24px!important
div>>>.page .annotationLayer section[data-annotation-id='952R']
  top 500px!important
  left 113px!important
  width 660.4px!important
  height 28px!important
div>>>.page .annotationLayer section[data-annotation-id='953R']
  top 547px!important
  left 114px!important
  width 660.4px!important
  height 28px!important
div>>>.page .annotationLayer section[data-annotation-id='954R']
  top 500px!important
  left 775px!important
  width 372.4px!important
  height 74px!important
div>>>.page .annotationLayer section[data-annotation-id='955R']
  top 595px!important
  left 114px!important
  width 1036.8px!important
  height 28px!important
div>>>.page .annotationLayer section[data-annotation-id='956R']
  top 672px!important
  left 835px!important
  width 86px!important
  height 48px!important
div>>>.page .annotationLayer section[data-annotation-id='957R']
  @supports (not (-webkit-hyphens:none))
    top 670px!important
    left 948px!important
  @media not all and (min-resolution:.001dpcm)
    @supports (-webkit-appearance:none)
      top 672px!important
      left 950px!important
  width 57.6px!important
  height 48px!important
  @media screen and (-webkit-min-device-pixel-ratio:0) and (min-resolution:.001dpcm)
    left 951px!important
    top 672px!important

div>>>.page .annotationLayer section[data-annotation-id='958R']
  top 672px!important
  left 1036px!important
  width 115.2px!important
  height 48px!important
div>>>.page .annotationLayer section[data-annotation-id='959R']
  top 767px!important
  left 835px!important
  width 57.6px!important
  height 48px!important
div>>>.page .annotationLayer section[data-annotation-id='960R']
  top 767px!important
  left 921px!important
  width 201.6px!important
  height 48px!important
div>>>.page .annotationLayer section[data-annotation-id='987R']
  top 1079px!important
  left 257px!important
  width 450px!important
  height 48px!important
div>>>.page .annotationLayer section[data-annotation-id='992R']
  top 1077px!important
  left 827px!important
  width 159px!important
  height 48px!important
  @media screen and (-webkit-min-device-pixel-ratio:0) and (min-resolution:.001dpcm)
    top 1080px!important
div>>>.page .annotationLayer section input[type="text"].comb
  letter-spacing calc(30px - 1ch)!important
div>>>.page .annotationLayer section input
  font-size 18px!important
div>>>.page .annotationLayer section textarea
  font-size 18px!important
.modal .animation-content .modal-card >>> .modal-card-head
  padding 0;
.modal >>> .animation-content
  width 90%;
.modal-close
  top 0;
  right 0;
.pdfViewer
  min-width 650px;
  min-height 700px;
.modal .animation-content .modal-card .modal-card-body >>> .b-tooltip
  width auto;
  display block;
.modal .animation-content .modal-card .modal-card-body >>> .b-tooltip::after
  font-size 14px;
  padding-left 6px;
  padding-right 6px;
  background-color #fff;
  border 1px solid red;
  color red
.modal .animation-content .modal-card .modal-card-body >>> input.is-danger
  border-color red;
.modal .animation-content .modal-card .modal-card-body >>> input
  color black;
.modal .animation-content .modal-card .modal-card-body >>> p.is-danger
  display none;
.modal .animation-content .modal-card .modal-card-body >>> small
  display none;
div>>>.page .annotationLayer .redBorder
  border 1px solid red;
div>>>.page .annotationLayer section
  transform none!important
div>>>.page .annotationLayer section input[disabled='true']
  background-color rgba(0, 54, 255, 0.13)
.modal-card-body
  position: relative;
.white-board
  position absolute
  background-color white
  width 100%
  height 100%
  z-index 1
</style>
